import type { ReactNode } from 'react';

type Props = {
    title: string;
    titleId?: string;
    children: ReactNode;
};

export function ProfileFormSection({ title, titleId, children }: Props) {
    return (
        <section className="flex flex-col gap-8 pt-6 pb-8 px-[var(--sheet-gutter)] border-t first:border-t-0">
            <h2 id={titleId} className="text-xl font-bold">
                {title}
            </h2>
            <div className="flex flex-col gap-8">{children}</div>
        </section>
    );
}
